import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { teamsCollection } from './teams-collection';
export const attachTeamsTabSync = ()=>attachTabSync({
        collection: teamsCollection,
        sync: getTabSync()
    });
